<template>
  <div class="outer"> <!-- outer container -->
<section class="section">
<div class="container">
    <div class="columns">
        <section class="section column lista is-half">
            <span class="title is-2">List - A</span>
            <section class="section">
                <p># of items: {{ listLengthA }} </p>
            </section>
        <!-- lista stuff -->
        
            <div class="field lista">
                <textarea 
                cols="30"
                rows="5"
                class="textarea"
                v-model.trim="lista"
                placeholder="Main list"
                ></textarea>

                <section class="section lista">
                    <div class="columns">
                        <div class="column"><button  class="button" @click="helpA"><span class="subtitle is-4">👋</span></button></div>
                        <!-- <div class="column"><button  class="button" @click="checkA">✅</button></div> -->
                        <!-- <div class="column"><button  class="button" @click="doWorkA">🏋🏽‍</button></div> -->
                        <div class="column"><button  class="button" @click="clearA">☀️</button></div>
                    </div>
                </section>
            </div>
        </section>

        <section class="section column listb is-half">
            <span class="title is-2">List - B</span>
            <section class="section">
                <p># of items: {{ listLengthB }} </p>
            </section>
        <!-- lista stuff -->
        
            <div class="field listb">
                    <textarea 
                    cols="30"
                    rows="5"
                    class="textarea"
                    placeholder="List to remove"
                    v-model="listb"
                    ></textarea>
                    <div class="section listb">
                        <div class="columns">
                        <div class="column"><button  class="button" @click="helpB"><span class="subtitle is-4">👋</span></button></div>
                        <!-- <div class="column"><button  class="button">✅</button></div> -->
                        <!-- these buttons were related more to email checking and console .logging -->
                        <!-- <div class="column"><button  class="button"  @click="doWorkB">🏋🏽‍</button></div> -->
                        <div class="column"><button  class="button" @click="clearB">☀️</button></div>
                        </div>
                    </div>
            </div>
        </section>
    </div>
    <div class="columns">
        <div class="column listc">
    <section class="section listc">
        <div class="container">
            <h2 class="title is-2">List C = (A-B) </h2>
            <p class="subtitle is-5"># of items: {{ listLengthResult }} </p>
            <div class="field listc">
                <textarea 
                    cols="30"
                    rows="4"
                    class="textarea is-large"
                    placeholder="Result List"
                    readonly
                    v-model="result"
                    ></textarea>
            </div>

             <section class="section listc">
                <div class="columns">
                    <div class="column">
                        <button  class="button" @click="inAandNotB"><span class="subtitle is-4">{{ (lista == '' || listb =='') && result == '' ? "👁" : "🏋🏽‍"}}</span></button>
                        <!-- <button  class="button" @click="helpA"><span class="subtitle is-4">👋</span></button> -->
                    </div>
                    <!-- <div class="column"><button  class="button" @click="checkA">✅</button></div> -->
                    <!-- <div class="column"><button  class="button" @click="doWorkA">🏋🏽‍</button></div> -->
                    
                    <div class="column"><button  class="button" @click="clearResult"><span class="subtitle is-4">☀️</span></button></div>
                </div>
            </section>
        </div>
    </section>
    </div>
        </div>

  </div>  <!-- outer container -->
  </section>
  </div>
</template>

<script>
export default {
    name: "ListDiffer",
    data() {
        return {
            lista: '',
            listb: '',
            listAarray: [],
            listBarray: [],
            listLengthA: 0,
            listLengthB: 0,
            listLengthResult: 0,
            validEmails: [],
            emailObjects: [],
            inBnotA: [],
            inAnotB: [],
            result: []
        }
    },
    methods: {
        
        // this helper functions load up the lists
        helpA: function() {
            this.lista = "c@c.com\nb@b.com\ne@e.com\nd@d.com"
            this.listLengthA = this.lista.split('\n').length
        },
        helpB: function() {
            this.listb = "b@b.com\nd@d.com"
            this.listLengthB = this.listb.split('\n').length
        },
        clearA: function() {
            this.lista = ''
            this.listLengthA = 0
        },
        clearB: function() {
            this.listb = ''
            this.listLengthB = 0
        },
        clearResult: function() {
            // would be good to add an undo feature here.
            this.result = []
            this.listLengthResult = 0
            this.clearA()
            this.clearB()
        },
        inBandNotA: function() {
            if(this.lista == '') {
                this.helpA()
            }
            if(this.listb == '') {
                this.helpB()
            }
            this.doWorkA()
            this.doWorkB()

            let a = this.listAarray
            let b = this.listBarray
            let x;
            const bNotInA = []
            function notInA(email) {
                return !a.includes(email)
            }
            for (x of b) {
                if (notInA(x)) { bNotInA.push(x) }
            }

            this.inBnotA = [...bNotInA]
            this.result = [...bNotInA]
            this.listLengthResult = this.result.length
            this.result = this.result.join('\n')
            
            // console.log("After processing unsubscribers, you're left with: ", this.result)

        },
        inAandNotB: function() {
            if(this.lista == '') {
                this.helpA()
            }
            if(this.listb == '') {
                this.helpB()
            }
            this.doWorkA()
            this.doWorkB()

            let a = this.listAarray
            let b = this.listBarray
            let x;
            const aNotInB = []
            function notInB(item) {
                return !b.includes(item)
            }
            for (x of a) {
                if (notInB(x)) { aNotInB.push(x) }
            }

            this.inAnotB = [...aNotInB]
            this.result = [...aNotInB]
            this.listLengthResult = this.result.length
            this.result = this.result.join('\n')
            
            // console.log("After processing unsubscribers, you're left with: ", this.result)

        },
        doWorkA: function() {
            // split the lines
            this.lineSplitterA()
            // finish with results
            this.checkEachItem(this.listAarray)
            // console.log("About to show the results")
            // this.objectifyValidEmails()
            // this.objectifyValidEmails()
            // this.objectifyValidEmails()
            // this.objectifyValidEmails()
            // this.showResults()
            
        },
        doWorkB: function() {
            // split the lines
            this.lineSplitterB()
            // finish with results
            this.checkEachItem(this.listBarray)
            // console.log("About to show the results")
        },
        objectifyValidEmails: function() {
            // console.log("about to objectify emails")
            // this gem turns an array into a deeper object
            // magic? who knows?
            this.validEmails.forEach(email => {
                this.emailObjects.push({ email : email })
            })
            this.emailObjects.forEach(obj => {
                obj.timestamp=new Date(Date.now()).toLocaleString('en-US')
            })
        },
        showResults: function() {
            // console.log("Entering showResults()")
            this.validEmails.forEach((email) => {
                // console.log(email + " is valid")
            })
            // console.log("RESULTS: WE HAVE: ", this.emailObjects.length, " valid emails")
            this.emailObjects.forEach( obj => {
                // console.log(obj.email)
                // console.log(obj.timestamp)
            })
        },
        
        checkEachItem: function(arrayToCheck){
            const localArray = []
            // console.log("Entered checkEachItem")
            arrayToCheck.forEach(function(listItem) {
                // const old_regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
                const regex = /^\w+([+\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
                // console.log("About to test ", listItem)
                // console.log("IS THE REGEZX WORKIN: ", regex.test("fun@gmail.com"))
                // console.log("IS THE REGEZX WORKIN on the list item: ", regex.test(listItem))
                if (regex.test(listItem)) {
                    // console.log(listItem + "is an email")
                    localArray.push(listItem)
                } else {
                    // console.log("NOT AN EMAIL: ", listItem)
                }
            })
            this.validEmails = localArray
            // console.log("Exiting checkEachItem()")
        },
        splitListCount: function() {
            if (!this.lista == '') {
                this.listLengthA = this.lista.split('\n').length
                return this.listLengthA
            } else {
                // console.log("no list seems to be present")
                return false
            }
        },
        lineSplitterA: function() {
            // take in string - split into array
            const newArray =  this.lista.split('\n')
            // check if we got an array
            if (Array.isArray(newArray)) {
                this.listAarray = newArray
                // console.log("in lineSplitterA - length of array is ", this.listAarray.length)
            }  
        },
        lineSplitterB: function() {
            // take in string - split into array
            const newArray =  this.listb.split('\n')
            // check if we got an array
            if (Array.isArray(newArray)) {
                this.listBarray = newArray
                // console.log("in lineSplitterB - length of array is ", this.listBarray.length)
            }  
        }
    }
}
</script>

<style>
.lista {background-color: #93CBF5;}
.listb {
    background-color: #A5D3F6;
}
.listc {
    background-color: #7FB8D1;
}
</style>